import PageComponent from '../../common/component/page-component';

class HomepageTeaser extends PageComponent {
	// constructor({
	// 	root,
	// 	element,
	// }) {
	// 	super({root: root, element: element});
	// }

	prepare() {
		console.log('prepare hompage teaser');
	}
}

export default HomepageTeaser;
